import { render, staticRenderFns } from "./dc.vue?vue&type=template&id=6824a9a8&scoped=true"
import script from "./dc.vue?vue&type=script&lang=js"
export * from "./dc.vue?vue&type=script&lang=js"
import style0 from "./dc.vue?vue&type=style&index=0&id=6824a9a8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6824a9a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6824a9a8')) {
      api.createRecord('6824a9a8', component.options)
    } else {
      api.reload('6824a9a8', component.options)
    }
    module.hot.accept("./dc.vue?vue&type=template&id=6824a9a8&scoped=true", function () {
      api.rerender('6824a9a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/base-data/dc.vue"
export default component.exports